import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { TranslateService } from '@ngx-translate/core';
import Hashids from 'hashids';
import { SessionStorageService } from 'ngx-webstorage';
import { fromEvent } from 'rxjs';
import { LoginService } from 'src/app/core/login/login.service';

@Component({
  selector: 'wsb-compose-email-editor',
  templateUrl: './compose-email-editor.component.html',
  styleUrls: ['./compose-email-editor.component.scss'],
  standalone: false
})
export class ComposeEmailEditorComponent implements OnInit {
  @ViewChild('iframeEditorMail', { static: true }) iframeEditorMail: ElementRef;
  hashids: Hashids;
  private id = '';

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private auth: AuthService,
    private sessionStorage: SessionStorageService,
    private loginService: LoginService
  ) {
    if (this.loginService.isUniversalLogin) {
      this.auth.getAccessTokenSilently().subscribe(token => {
        this.sessionStorage.store('wsb-auth0-token', token);
      });
    }
  }

  ngOnInit(): void {
    this.translateService.get('pages_salt_hashids').subscribe(salt => {
      this.hashids = new Hashids(salt, 26, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890');
      this.route.queryParams.subscribe(query => {
        this.id = query['issue'];
      });
      const idIssue = this.hashids.decode(this.id);
      const urlIndex = 'assets/static/editor-mail/index.html?issue=' + idIssue + '&id=' + this.id;
      this.iframeEditorMail.nativeElement.src = urlIndex;
    });

    fromEvent(this.iframeEditorMail.nativeElement, 'load').subscribe((event: Event) => {
      const url = this.iframeEditorMail.nativeElement.contentWindow.location.href;
      if (url.includes('/mail/send')) {
        // next page
        window.location.assign(url);
      } else if (url.includes('/mail/list')) {
        // prev page
        window.location.assign(url);
      }
    });
  }
}
